import { render } from "./ProfileIndustryCompetenceScoring.vue?vue&type=template&id=3c520698&scoped=true"
import script from "./ProfileIndustryCompetenceScoring.vue?vue&type=script&lang=js"
export * from "./ProfileIndustryCompetenceScoring.vue?vue&type=script&lang=js"

import "./ProfileIndustryCompetenceScoring.vue?vue&type=style&index=0&id=3c520698&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c520698"]])

export default __exports__